<template>
  <div class="topics-archive-page">
    <h1 class="topics-archive-page__headline">
      {{ headline }}
    </h1>

    <h2 class="topics-archive-page__subline">
      <slot name="subline" />
    </h2>

    <div class="topics-archive-page__text">
      <slot name="text" />
    </div>

    <div class="topics-archive-page__categories">
      <slot name="pinned-topics" />
    </div>

    <h2 class="topics-archive-page__subline topics-archive-page__subline--mt">
      <slot name="subline-earlier-topics" />
    </h2>

    <div class="topics-archive-page__text">
      <slot name="text-earlier-topics" />
    </div>

    <div class="topics-archive-page__categories">
      <slot name="earlier-topics" />
    </div>

    <div class="topics-archive-page__content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TopicsArchivePage",

  props: {
    headline: {
      type: String,
      default: null,
    },
  },
};
</script>

<style  lang="scss">
@import "../scss/importall.scss";

.topics-archive-page__headline {
  @extend %h1;
  margin-top: 0;
  margin-bottom: 0.5em;
}

.topics-archive-page__subline {
  @extend %h3;
  margin-top: 0;
  margin-bottom: 1em;

  &--mt {
    margin-top: 6rem;
  }
}

.topics-archive-page__text {
  @extend %text-excerpt;
}

.topics-archive-page__content {
  padding: 0;
}
</style>
